import { LiabilityTypeBuilder, LiabilityFormData, LiabilityRequestData } from './types';

import { format } from 'utils/date';
import { createLiability } from '../liabilities';
import { FIELDS } from 'modules/cm/fields/types';

export class CreditCommitmentTypeBuilder implements LiabilityTypeBuilder {
  private saveData: LiabilityRequestData;
  private data: LiabilityFormData;

  constructor(liabilityId: number) {
    this.saveData = {
      id: liabilityId,
      type: null,
      balance: null,
      amount: null,
      endDate: null,
      willBeClearedBeforeLoan: null,
      willBeClearedByLoan: null,
      creditLimit: null,
      description: null,
      frequency: null,
      totalNumberOfProperties: null,
    };
    this.data = createLiability(liabilityId);
  }

  set formData(value: LiabilityFormData) {
    this.data = value;
  }

  get formData() {
    return this.data;
  }

  getData() {
    return this.saveData;
  }

  setType() {
    return (this.saveData.type = this.formData[FIELDS.EXPENDITURE_TYPE]);
  }

  setAmount() {
    this.saveData.amount = this.formData[FIELDS.EXPENDITURE_AMOUNT];
  }

  setCreditCardBalance() {
    this.saveData.balance = Number(this.formData[FIELDS.BALANCE]);
  }

  setIsClearedBeforeLoanCompletes() {
    const val = this.formData[FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN];

    if (val !== null && typeof val !== 'undefined') {
      this.saveData.willBeClearedBeforeLoan = val;
    } else {
      this.saveData.willBeClearedBeforeLoan = null;
    }
  }

  setIsClearedByLoanCompletes() {
    const val = this.formData[FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN];

    if (val !== null && typeof val !== 'undefined') {
      this.saveData.willBeClearedByLoan = val;
    } else {
      this.saveData.willBeClearedByLoan = null;
    }
  }

  setEndDate() {
    const endDate = this.formData[FIELDS.EXPENDITURE_END_DATE];
    this.saveData.endDate = endDate ? format(endDate).fromViewToRequest() : null;
  }

  setDescription() {
    this.saveData.description = this.formData[FIELDS.EXPENDITURE_DESCRIPTION];
  }

  setCreditLimit(): void {
    this.saveData.creditLimit = Number(this.formData[FIELDS.EXPENDITURE_CREDIT_LIMIT]);
  }

  setFrequency(): void {
    this.saveData.frequency = this.formData[FIELDS.EXPENDITURE_FREQUENCY];
  }

  setId(): void {
    this.saveData.id = this.formData[FIELDS.EXPENDITURE_ID];
  }

  setTotalNumberOfProperties(): void {
    this.saveData.totalNumberOfProperties = Number(this.formData[FIELDS.EXPENDITURE_CREDIT_LIMIT]);
  }
}
